// base
import { useEffect } from 'react';
import { Route } from 'react-router-dom';

// hooks
import { useUser } from 'hooks';

// routes
import { ROUTE_SIGN_IN } from './const';

export const PrivateRoute = (props) => {
  const { component, fallback, isPermission, ...rest } = props;

  const { isLogin, userInfo } = useUser();

  useEffect(() => {
    if (!isLogin) {
      window.location.href = ROUTE_SIGN_IN;
    }
  }, [isLogin]);

  if (isLogin === undefined) return <div />;

  return <Route {...rest} component={isPermission(userInfo) ? component : fallback} />;
};
